module.exports = __webpack_public_path__ + "static/img/qr-code.73792fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/qr-code.png
// module id = U+iS
// module chunks = 1